export default __webpack_public_path__ + "static/media/icon-invisible-20.0d7b4882.svg";